var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6485 4.68485C14.0687 1.10505 8.26466 1.10505 4.68485 4.68485C2.89495 6.47476 2 8.82071 2 11.1667M4.68485 17.6485C8.26466 21.2283 14.0687 21.2283 17.6485 17.6485C19.4384 15.8586 20.3333 13.5126 20.3333 11.1667M18.5 2V5.575C18.5 5.62563 18.459 5.66667 18.4083 5.66667H14.8333M3.83333 20.3333V16.7583C3.83333 16.7077 3.87437 16.6667 3.925 16.6667H7.5M14.8333 9.33333L10.1 13.6364C9.92516 13.7953 9.65818 13.7953 9.48336 13.6364L7.5 11.8333",
    stroke: "#363636",
    strokeWidth: 1.67,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSubscriptionIcon);
export default __webpack_public_path__ + "static/media/darkSubscriptionIcon.377abbeef86cb17bc959a7453796cb63.svg";
export { ForwardRef as ReactComponent };